import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBtns from '../Components/NavBtns.jsx';
import { ResultsContext } from '../Store/ResultsContext';
import Footer from '../Components/Footer.jsx';
import { auth } from "../Functions/SignUp/Firebse.js";
import "./Pages.css";

const ScoreBoard = () => {
  const { results } = useContext(ResultsContext);
  const [userDet, setUserDet] = useState(null);

  const fetchData = async () => {
    auth.onAuthStateChanged(async (user) => {
      setUserDet(user);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Check if all scores are zero
  const allZeroScores = results.every(result => (
    result.WPM === 0 &&
    result.CPM === 0 &&
    result.mstk === 0 &&
    result.points === 0 &&
    result.acc === 0 &&
    result.misPenal === 0
  ));

  return (
    <>
      <NavBtns />
     
      
          {userDet && (
            <>  <div style={{ marginTop: "10px" }} className="user-data">
              <img src={userDet.photoURL} width="10%" style={{ borderRadius: "50%" }} alt="User" />
              <h7>{userDet.displayName}</h7>
              </div>
           </>
          )}
       
        {userDet ? 
        "" : (<p>Login to save Scores</p>)}
        <div className="scoreboard">
          <h2>Score Board</h2>
          {allZeroScores ? (
            <div className="no-scores-message">
              <p>You didn't goyt a score yet!</p>
            </div>
          ) : (
            <table className="results-table">
              <thead>
                <tr>
                  <th>Game</th>
                  <th>WPM</th>
                  <th>CPM</th>
                  <th>Mistakes</th>
                  <th>Accuracy</th>
                  <th>Mistake Penalty</th>
                </tr>
              </thead>
              <tbody>
                {results.map((result, index) => (
                  <tr key={index}>
                    <td>Try {index + 1}</td>
                    <td>{Math.floor(result.WPM)}</td>
                    <td>{Math.floor(result.CPM)}</td>
                    <td>{Math.floor(result.mstk)}</td>
                    <td>{Math.floor(result.acc)}%</td>
                    <td>{Math.floor(result.misPenal)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <Footer />
    </>
  );
};

export default ScoreBoard;
